<template>
  <v-sheet tile class="fill-height">
    <v-container>
      <div class="primary-gradient-background">
        <div class="avatar large">
          <SpotS3Image :image-path="brand.image"></SpotS3Image>
        </div>
        <div class="brand-title">
          <span>{{brand.name}}</span>
        </div>
        <div class="action-btns">
          <v-btn :loading="loadingState" small rounded outlined color="white"
                 :to="{name:PAGE_IDS.BRAND_EDIT, params:{brand_id:brand.id}}">
            <v-icon>edit</v-icon>
            Edit
          </v-btn>
          <v-btn :loading="loadingState" small rounded outlined color="white" @click.native.prevent="deleteBrand">
            <v-icon>delete</v-icon>
            Delete
          </v-btn>
        </div>
      </div>
      <v-spacer style="height:236px"></v-spacer>
      <UsersList caption="Brand Managers" empty_text="No Brand Managers on file" :users="brand.brandmanagers"
                 v-on:updateUsers="updateBrandManagers"></UsersList>
    </v-container>
  </v-sheet>
</template>

<script>
  import {mapGetters} from "vuex";
  import BrandTile from "./BrandTile";
  import {UsersList} from "../Users";
  import {doDeleteStore, updateBrand} from "../graphql/mutations";
  import {process_api_error} from "@/utils/utils"
  import {deleteBrand} from "../graphql/mutations";
  import {PAGE_IDS} from "../utils/constants"
  import SpotS3Image from "../Pages/SpotS3Image";
  import {getBrand} from "../graphql/queries";

  export default {
    name: "BrandDetails",
    components: {SpotS3Image, UsersList, BrandTile},
    computed: {
      ...mapGetters(['getBrandById', 'loadingState']),
      brand() {
        return this.getBrandById(this.$route.params.brand_id);
      }
    },
    methods: {
      deleteBrand() {
        var that = this
        var brand_id = that.brand.id
        that.$router.push({name: PAGE_IDS.BRANDS_LIST})
        that.$store.dispatch('removeBrand', brand_id)
        this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(deleteBrand, {input: {id: brand_id}}))
          .then(() => {
          })
          .catch((e) => {
            this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(getBrand, {id: brand_id}))
              .then((res) => {
                this.$store.dispatch('addBrand', res.data.getBrand)
              })
            process_api_error(`Error Deleting Brand`, e)
          });
      },

      updateBrandManagers(new_managers) {
        this.$store.dispatch('updateBrand', {
          id: this.brand.id,
          name: this.brand.name,
          image: this.brand.image,
          brandmanagers: new_managers
        })
        this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(updateBrand, {
          input: {
            id: this.brand.id,
            name: this.brand.name,
            image: this.brand.image,
            brandmanagers: new_managers
          }
        }))
          .then((res) => {


          })
          .catch((e) => {
            this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(getBrand, {id: this.brand.id}))
              .then((res) => {
                this.$store.dispatch('updateBrand', {
                  id: res.data.getBrand.id,
                  name: res.data.getBrand.name,
                  image: res.data.getBrand.image,
                  brandmanagers: res.data.getBrand.brandmanagers
                })
              })
            process_api_error(`Error updating Brand`, e)
          });
      }
    }

  }
</script>

<style lang="scss" scoped>
  .primary-gradient-background {
    align-items: center;
    text-align: center;
    justify-content: center;
    display: grid;
    grid-template-rows: auto 1rem auto;
    padding-top: 1rem;

    .brand-title {
      text-align: center;
      font-size: 18px;
      color: white;
      font-weight: 500;
    }

    .action-btns {
      .v-btn {
        margin: 0 .4rem;
        height: 32px;
        text-transform: none;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/Brands/BrandDetails.vue